import { SHARED_DATA_MEDIA_TYPES_MAP, SharedDataType } from 'APP/constants/sharedData';
import { GetMessagesDirection } from 'APP/model/message/messageModel.types';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';

import loadUnknownDataFromMessages from '../../relationships/loadUnknownDataFromMessages';

interface IMessagesByMediaTypesParams {
  groupId: string;
  cursorTs?: number;
  type: SharedDataType;
  direction: string;
  isShowLoading?: boolean;
}

export async function getMessagesByMediaTypes({
  groupId,
  cursorTs = 0,
  type,
  direction,
  isShowLoading = true,
}: IMessagesByMediaTypesParams): Promise<any> {
  const group = Entities.GroupsStore.getGroupById(groupId);
  const sharedData = group?.sharedData;
  const sharedDataType = sharedData?.[type];

  if (isShowLoading) {
    sharedDataType?.setLoading(true);
  }

  cursorTs = cursorTs || Date.now();

  try {
    const res = await messageModel.getMessagesByMediaTypes({
      groupId,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore // TODO: fix enum problem
      mediaTypes: SHARED_DATA_MEDIA_TYPES_MAP[type],
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore // TODO: fix enum problem
      direction,
      cursorTs: cursorTs.toString(),
    });

    if (res.messages) {
      await loadUnknownDataFromMessages({ messages: res.messages });

      sharedData?.addMessages(res.messages);
    }

    const newCursorTs = res.cursorTs ? parseInt(res.cursorTs, 10) : 0;
    sharedDataType?.setCursorTs(newCursorTs);

    if (isShowLoading) {
      sharedDataType?.setLoading(false);
    }

    if (!res.cursorTs && direction === GetMessagesDirection.Oldest) {
      sharedDataType?.setLastMessageTs(Math.max(cursorTs, sharedDataType.lastMessageTs));
      sharedDataType?.setHasMore(false);
    }

    if (direction === GetMessagesDirection.Newest) {
      sharedDataType?.setLastMessageTs(newCursorTs || group?.lastMessageTs || 0);
    }

    return res;
  } catch (error) {
    if (isShowLoading) {
      sharedDataType?.setLoading(false);
    }

    return {};
  }
}
